var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isWhiteLabel)?_c('div',{staticClass:"loading-screen"},[_c('aha-loader')],1):_c('div',{staticClass:"loading-screen-white-label"},[_c('div',[_c('aha-spinner',{attrs:{"size":"lg","variant":"tail"}}),_c('p',{staticClass:"mt-6"},[_vm._v(" "+_vm._s(_vm.$i18nPresenter.t('Just a moment please...'))+" ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }